<template>
    <rkm-layout-body title="Lista de sala">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-sala-create' })"
                color="primary"
                authorize="store-cadastro-sala"
            >
                Cadastrar sala
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/sala/List'

export default {
    components: { List },
}
</script>